import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const RewindFifteenIcon: FunctionComponent<RewindFifteenIconProps> = ({
  size = 42,
  backgroundFillColor,
  textFillColor,
}) => {
  const { colors } = useTheme()
  const backgroundColor = backgroundFillColor ? backgroundFillColor : colors.backgroundSection
  const textColor = textFillColor ? textFillColor : colors.backgroundActive

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
      <Rect width='42' height='42' rx='21' fill={backgroundColor} />
      <Path
        d='M20.5 10C24.7089 10 28.3279 12.4824 30.0074 16.0605C30.3003 16.6845 29.9384 17.395 29.2836 17.6105C28.6299 17.8256 27.9339 17.4638 27.6192 16.8518C26.292 14.2704 23.5991 12.5 20.5 12.5C18.54 12.5 16.77 13.22 15.38 14.38L17.1464 16.1464C17.4614 16.4614 17.2383 17 16.7929 17H11.5C11.2239 17 11 16.7761 11 16.5V11.2071C11 10.7617 11.5386 10.5386 11.8536 10.8536L13.6 12.6C15.45 11 17.85 10 20.5 10Z'
        fill={textColor}
      />
      <Path
        d='M16.072 30V23.312H13.832V21.632H14.872C15.944 21.632 16.296 21.04 16.296 20.24V19.76H18.184V30H16.072ZM24.431 23.328C26.431 23.328 27.727 24.768 27.727 26.688C27.727 28.832 26.079 30.16 23.871 30.16C21.759 30.16 20.319 28.944 20.207 26.944H22.239C22.319 27.92 22.975 28.496 23.903 28.496C24.927 28.496 25.631 27.824 25.631 26.736C25.631 25.68 25.007 24.88 23.951 24.88C23.247 24.88 22.655 25.2 22.335 25.76L20.447 25.344L20.991 19.76H27.247V21.472H22.799L22.527 23.92C22.895 23.616 23.519 23.328 24.431 23.328Z'
        fill={textColor}
      />
    </Svg>
  )
}

type RewindFifteenIconProps = {
  size?: string | number
  backgroundFillColor?: string
  textFillColor?: string
}
